"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const theme_1 = require("@zapier/theme");
const containerStyle = core_1.css `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
function LoadingContent() {
    return (common_utils_1.isolateComponent("div", { css: containerStyle },
        common_utils_1.isolateComponent(design_system_1.Spinner, null),
        common_utils_1.isolateComponent(design_system_1.Spacer, { height: theme_1.Spacing.small }),
        common_utils_1.isolateComponent(design_system_1.Text, { color: "grey500" }, "Loading\u2026")));
}
exports.default = LoadingContent;
